const TopicSidebarNotFound = () => {
  return (
    <div className="-mt-3" aria-label="Error sidebar topic">
      <div className="pt-2">This topic could not be found.</div>
    </div>
  );
};

export default TopicSidebarNotFound;
